import 'github-markdown-css/github-markdown.css'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import App from './App'
import * as History from 'history'
import createStore from './modules/store'

const theme = createTheme({
  typography: {
    useNextVariants: true,
    button: {
      textTransform: 'none',
    },
    fontSize: 14,
  },
  mixins: {
    toolbar: {
      minHeight: 42,
    },
  },
  props: {
    MuiList: {
      dense: true,
    },
    MuiTable: {
      size: 'small',
    },
    MuiTextField: {
      variant: 'outlined',
    },
  },
  palette: {
    primary: {
      main: '#263238',
    },
    secondary: {
      main: '#263238',
    },
  },
})

const history = History.createBrowserHistory()
export const store = createStore(history)

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
)
